import React from 'react';

// Impressum gemäß § 5 DDG (Digitale-Dienste-Gesetz, ehem. § 5 TMG).
function Impressum() {
  return (
    <div className="min-vh-100 d-flex flex-column"
         style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>

      {/* Navigation */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
        <div className="container">
          <a className="navbar-brand" href="/">
            <i className="bi bi-cup-hot-fill text-warning me-2"></i>
            Oktoberfest Personalplanung
          </a>
          <a className="nav-link text-white ms-auto" href="/">
            <i className="bi bi-arrow-left me-1"></i>
            Zurück zur Startseite
          </a>
        </div>
      </nav>

      {/* Inhalt */}
      <div className="flex-grow-1 d-flex justify-content-center align-items-start px-3 py-4">
        <div className="card border-0 shadow-lg w-100" style={{ maxWidth: '760px', borderRadius: '16px' }}>
          <div className="card-body p-4 p-md-5">
            <h1 className="fw-bold mb-4">
              <i className="bi bi-info-circle-fill text-primary me-2"></i>
              Impressum
            </h1>

            <h2 className="h5 fw-bold mt-4">Angaben gemäß § 5 DDG</h2>
            <p className="mb-1">Bavarian Concept Group GmbH</p>
            <p className="mb-1">Bürkelweg 18</p>
            <p className="mb-1">85540 Haar</p>
            <p className="mb-0">Deutschland</p>

            <h2 className="h5 fw-bold mt-4">Vertreten durch</h2>
            <p className="mb-0">Geschäftsführer: Philipp Rank</p>

            <h2 className="h5 fw-bold mt-4">Kontakt</h2>
            <p className="mb-1">Telefon: +49 15234107290</p>
            <p className="mb-0">
              E-Mail: <a href="mailto:info@conceptgroup.de">info@conceptgroup.de</a>
            </p>

            <h2 className="h5 fw-bold mt-4">Registereintrag</h2>
            <p className="mb-1">Eintragung im Handelsregister.</p>
            <p className="mb-1">Registergericht: Amtsgericht München</p>
            <p className="mb-1">Registernummer: HRB 222974</p>
            <p className="mb-0">Sitz der Gesellschaft: Haar</p>

            <h2 className="h5 fw-bold mt-4">Umsatzsteuer-ID</h2>
            <p className="mb-0">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              DE304715148
            </p>

            <h2 className="h5 fw-bold mt-4">
              Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
            </h2>
            <p className="mb-0">Philipp Rank, Anschrift wie oben</p>

            <h2 className="h5 fw-bold mt-4">Haftung für Inhalte</h2>
            <p className="text-muted small mb-0">
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf
              diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10
              DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
              gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
              forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>

            <h2 className="h5 fw-bold mt-4">Haftung für Links</h2>
            <p className="text-muted small mb-0">
              Unser Angebot enthält ggf. Links zu externen Websites Dritter, auf deren
              Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
              Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten
              ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>

            <hr className="my-4" />
            <p className="text-muted small mb-0">
              <i className="bi bi-shield-lock me-1"></i>
              Hinweis: Bitte die Angaben vor Veröffentlichung rechtlich prüfen lassen.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Impressum;
